import { Box, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, Grid } from "@mui/material";
import { useCallback, useState } from "react";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import { apiNoLoading, IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import theme from "src/theme/light";

interface ModalRevendaServicoDesabilitadoProps {
  isOpen: boolean;
  closeModal: () => void;
  onConfirm: () => void;
  idProjeto: number | null
}

export const ModalRevendaServicoDesabilitado = ({ closeModal, onConfirm, isOpen, idProjeto }: ModalRevendaServicoDesabilitadoProps) => {
  const [removerServico, setRemoverServico] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const removeServicoConfirmacao = useCallback(async ()=>{
    if (!idProjeto) return;

    const request: IDataRequest = {
      url: `/projetos/${idProjeto}`,
      data: {
          servico: null,
          valor_servico: 0,
          valor_servico_pis_cofins: 0,
          alterar_servico: true,
          atualizar_proposta: true,
          justificativa_valor_servico: null,
      }
    }

    setIsLoading(true)
    const response: IDataResponse = await apiNoLoading.put(request).finally(() => setIsLoading(false));
    if (response.statusCode !== STATUS_CODE.OK) return;
    
    onConfirm();
  },[idProjeto, onConfirm])

  return (
    <Dialog open={isOpen} onClose={closeModal} maxWidth='md' >
      <DialogTitle>
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          <Box>Atenção!</Box>
        </Box>
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          <u>Importante</u>: Revenda não habilitada para venda com valor de <br/>serviço. Consulte seu vendedor ou remova o serviço!
        </DialogContentText>
        <Grid container size={12}>
          <FormControlLabel
              label={(
                  <Box marginTop={2} display={"flex"} flexDirection={"column"}>
                      <span>Remover valor de serviço do projeto</span>
                      <span style={{ fontSize: 12, color: theme.palette.error.main }}>Ao selecionar essa opção, o novo valor de serviço será R$ 0,00.</span>
                  </Box>
              )}
              control={
                  <Checkbox checked={removerServico} onChange={(_, checked) => setRemoverServico(checked)} />
              }
          />
        </Grid>
      </DialogContent>
      <DialogActions>
          <FlatButton
              color="inherit"
              variant="contained"
              disableElevation
              text="Fechar"
              onClick={closeModal}
          />

          <FlatButton
            color="primary"
            variant="contained"
            disabled={!removerServico || isLoading}
            disableElevation
            text={isLoading ? "Salvando..." : "Salvar"}
            onClick={removeServicoConfirmacao}
          />
      </DialogActions>
    </Dialog>
  )
}